import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/gigabet/images/racing/mysteryBetLogo.svg';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 1,
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: {
    variant: 'odds',
    h: '34px',
    sx: {
      span: {
        color: 'alpha.800',
        textShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.6)',
      },
    },
  },
  imageLogo: {
    w: '250px',
    src: mysteryLogo,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  iconMystery: {},
  flexWrapperMysteryLabelView: {
    color: 'white',
    fontFamily: 'accent',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontWeight: 'normal',
    gap: 1,
    lineHeight: 'normal',
    alignItems: 'center',
  },
  buttonAddToBetslip: {
    variant: 'quickAccess',
    h: '34px',
    sx: {
      '&&': {
        borderLeftRadius: 'none',
        ms: '0',
      },
    },
  },
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'white',
    h: '34px',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'base',
    borderRightRadius: 'none',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'sm',
    fontFamily: 'accent',
    fontWeight: 'normal',
    sx: {
      '&&': {
        px: [2, 3],
      },
    },
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'blackAlpha.400',
    borderRadius: 'base',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    px: '3',
    color: 'white',
    overflow: 'hidden',
    mx: 'auto',
  },
  flexWrapperMysteryPlacedBetView: {
    fontFamily: 'accent',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    p: '2',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    my: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bgGradient: 'linear-gradient(180deg, #FBFCFD -5.63%, #A9B1CF 137.93%)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.40) inset, 0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: 'base',
    boxSize: '10',
    p: '2',
    color: 'beta.500',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
    cursor: 'pointer',
    h: '34px',
  },
  flexWrapperWithTooltip: {
    gap: 2,
  },
  imageMysteryBet: {
    w: '5',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    fontSize: 'sm',
    color: 'white',
    fontFamily: 'accent',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
    textShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  textPriceInfo: {
    fontSize: 'sm',
    color: 'alpha.400',
    fontFamily: 'accent',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
    textShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  textRollover: {
    fontSize: 'sm',
    color: 'alpha.400',
    fontFamily: 'accent',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  textError: {
    color: 'white',
    fontFamily: 'accent',
    fontWeight: 'normal',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontStyle: 'normal',
    fontSize: 'xs',
  },
  iconBack: {
    boxSize: '10',
    color: 'alpha.400',
    height: '34px',
  },
  iconRace: { color: 'beta.100', mb: '1.5' },
  textSpanWhite: {
    color: 'white',
  },
  buttonRollOver: {
    variant: 'secondary',
    h: '24px',
    _disabled: {
      bg: 'beta.800',
      boxShadow:
        '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
      color: 'alpha.400',
    },
  },
  spanSelectionText: {
    color: 'alpha.400',
  },
  spanPositionType: {
    color: 'alpha.400',
  },
  tooltipIcon: {
    color: 'beta.700',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.25)',
  },
};
